import DistributorLayout from '@/layouts/DistributorLayout.vue'

export default [
  {
    path: '/rental-products/repair-files/:repairFileBoomerangId',
    name: 'rentalProductList',
    component: () => import('@/views/restricted/rental-products/RentalProductListView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_RENTAL_CREATE'],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/rental-products/:rentalProductId(\\d+)/repair-files/:repairFileBoomerangId',
    name: 'rentalProductDetail',
    component: () => import('@/views/restricted/rental-products/RentalProductDetailView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_RENTAL_CREATE'],
      menuSelected: 'repairFiles'
    }
  }
]
